<template>
    <div>
      <slot />
    </div>
  </template>
  
  <style>
  </style>